<!-- 预览入口卡片 -->
<template>
    <div class="preview-card">
        <div class="title">
            您的个人信息将呈现在律临PC/移动端个人主页上
        </div>
        <div class="pic"></div>
        <div class="btn" @click="clickPreview">预览我的主页</div>
    </div>
</template>

<script>
export default {
    methods: {
        // 点击预览
        clickPreview() {
            this.$emit('clickPreview');
        }
    }
};
</script>

<style lang='less' scoped>
.preview-card {
    width: 214px;
    padding: 18px;
    background: #FFFFFF;
    border: 1px solid rgba(183,185,193,0.26);
    box-shadow: 0px 10px 30px 0px rgba(132,134,145,0.08);
    border-radius: 8px;

    .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #848691;
        line-height: 22px;
        font-weight: 400;
    }

    .pic {
        width: 176px;
        height: 104px;
        background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/perview-card.png') no-repeat center center / 100% 100%;
        border: 1px solid rgba(183,185,193,0.26);
        border-radius: 8px;
        margin-top: 12px;
    }
    .btn {
        margin-top: 18px;
        width: 178px;
        height: 32px;
        background: #05F;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #FFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        line-height: 32px;
        border-radius: 5px;
        cursor: pointer;
    }
}
</style>
